import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-wem-recent-interactions-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWemRecentInteractionsIconProps extends SvgIconProps {}

/**
 * Component used to render WEM Recent Interactions tab Icon
 * @example
 */
export function CcfWemRecentInteractionsIcon(
  props: CcfWemRecentInteractionsIconProps
) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M19.5 15H13.6L14.6 13.9C14.8 13.7 14.8 13.4 14.6 13.2C14.4 13 14.1 13 13.9 13.2L12.1 15.2C11.9 15.4 11.9 15.7 12.1 15.9L13.9 17.9C14.1 18.1 14.4 18.1 14.6 17.9C14.8 17.7 14.8 17.4 14.6 17.2L13.6 16.1H19.5C19.8 16.1 20 15.9 20 15.6C20 15.2 19.8 15 19.5 15ZM6.4 4.99998L5.4 6.09998C5.2 6.29998 5.2 6.59998 5.4 6.79998C5.6 6.99998 5.9 6.99998 6 6.79998L7.8 4.79998C8 4.59998 8 4.29998 7.8 4.09998L6 2.09998C5.8 1.89998 5.5 1.89998 5.3 2.09998C5.1 2.29998 5.1 2.59998 5.3 2.79998L6.3 3.89998H0.5C0.2 3.99998 0 4.19998 0 4.49998C0 4.79998 0.2 4.99998 0.5 4.99998H6.4ZM19 8.69998C18.5 8.09998 17.9 7.69998 17.1 7.29998L16 6.89998L16.9 6.09998C17.2 5.89998 17.4 5.59998 17.6 5.29998C17.9 4.79998 18.1 4.09998 18.1 3.49998C18.1 2.69998 17.8 1.79998 17.2 1.19998C17 0.999979 16.9 0.899979 16.6 0.699979C15.4 -0.100021 13.7 0.0999789 12.8 1.19998C12.3 1.89998 12 2.69998 12 3.49998C12 4.09998 12.2 4.69998 12.5 5.29998C12.7 5.59998 12.9 5.89998 13.2 6.09998L14.1 6.79998L13 7.29998C12.3 7.59998 11.6 8.09998 11.2 8.69998C10.6 9.49998 10.2 11 10.2 11H20C20 11 19.6 9.49998 19 8.69998ZM7.1 16.4L6 15.9L6.9 15.1C7.2 14.9 7.4 14.6 7.6 14.3C7.9 13.8 8.1 13.1 8.1 12.5C8.1 11.7 7.8 10.8 7.2 10.2C7.1 9.99998 6.9 9.89998 6.7 9.69998C5.5 8.99998 3.8 9.19998 2.9 10.2C2.3 10.9 2 11.7 2 12.5C2 13.1 2.2 13.7 2.5 14.3C2.7 14.6 2.9 14.9 3.2 15.1L4.1 15.8L3 16.3C2.3 16.6 1.6 17.1 1.2 17.7C0.6 18.5 0.2 20 0.2 20H10C10 20 9.6 18.5 9 17.7C8.5 17.1 7.9 16.7 7.1 16.4Z"
        fill="#7D3CC8"
      />
    </SvgIcon>
  );
}

export default CcfWemRecentInteractionsIcon;
